import { render, staticRenderFns } from "./ListaDePagamentosEletronicos.vue?vue&type=template&id=087d6b64&scoped=true"
import script from "./ListaDePagamentosEletronicos.vue?vue&type=script&setup=true&lang=js"
export * from "./ListaDePagamentosEletronicos.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ListaDePagamentosEletronicos.vue?vue&type=style&index=0&id=087d6b64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087d6b64",
  null
  
)

export default component.exports